<template>
<div class="container-fluid pt-3">
    <div class="m-2">
        <div class="alert alert-primary h4 text-center">
            <linkto :link="'/'"/>
            Gördülő átlag
        </div>
    </div>
    <loading
    	:active.sync="isLoading" 
      	:is-full-page="true"
      	:can-cancel="true"
      	color="#007bff"
      	background-color="#ffffff"
    >
    </loading>
    <back-to-top bottom="50px" right="50px">
      	<button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
    <div class="row d-flex justify-content-center align-items-center text-center">
    	<div class="col-12 col-sm-6 col-md-3 col-lg-3">
        	<span class="h5">Régió</span>
        	<div class="input-group">
          		<input type="number" class="form-control text-center" v-model="search.regio_kezd"></input>
          		<input type="number" class="form-control text-center" v-model="search.regio_veg"></input>
        	</div>
        </div>
		<div class="col-12 col-sm-6 col-md-3 col-lg-3">
        	<span class="h5">Kezdő év</span>
           	<date-picker id="datum" name="date" class="text-center" v-model="search.date" :config="date_year_options"></date-picker>
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-3">
        	<span class="h5">Teljesítettség</span>
            <div class="input-group">
              	<input type="number" class="form-control text-center" v-model="search.telj_kezd"></input>
              	<input type="number" class="form-control text-center" v-model="search.telj_veg"></input>
              	<div class="input-group-append">
                	<span class="input-group-text">%</span>
              	</div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-3">
        	<span class="h5">Havi limit</span>
            <div class="input-group">
              	<input type="number" class="form-control text-center" v-model="search.limit_kezd"></input>
              	<input type="number" class="form-control text-center" v-model="search.limit_veg"></input>
              	<div class="input-group-append">
                	<span class="input-group-text">Ft</span>
              	</div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-3">
        	<span class="h5">Aktív hónapok</span>
            <div class="input-group">
              	<input type="number" class="form-control text-center" v-model="search.akt_kezd"></input>
              	<input type="number" class="form-control text-center" v-model="search.akt_veg"></input>
              	<div class="input-group-append">
                	<span class="input-group-text">hónap</span>
              	</div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
            <span class="h5">Gyorsválasztó</span>  
            <button type="button" class="btn-block text-center btn btn-primary" @click.prevent="regio(1000,1999)">1000-1999 Régió</button>  
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
            <span class="h5">Gyorsválasztó</span>  
            <button type="button" class="btn-block text-center btn btn-primary" @click.prevent="regio(5000,5999)">5000-5999 Régió</button>	
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
            <span class="h5">Gyorsválasztó</span>  
            <button type="button" class="btn-block text-center btn btn-primary" @click.prevent="regio(6000,6999)">6000-6999 Régió</button>
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
            <span class="h5">Gyorsválasztó</span>  
            <button type="button" class="btn-block text-center btn btn-primary" @click.prevent="regio(7000,7999)">7000-7999 Régió</button>  
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
        	<div class="input-group m-1">
              	<div class="input-group-prepend">
                	<div class="input-group-text">
                  		<input type="checkbox" v-model="search.automataa">
                	</div>
              	</div>
              	<input type="text" class="form-control" placeholder="Van automata" disabled>
            </div>	
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
        	<div class="input-group m-1">
              	<div class="input-group-prepend">
                	<div class="input-group-text">
                  		<input type="checkbox" v-model="search.automata_szerz">
                	</div>
              	</div>
              	<input type="text" class="form-control" placeholder="Van szerződés" disabled>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
        	<button @click.prevent="load" class="btn btn-block btn-primary m-1">
              	<i class="fas fa-search"></i>
              	<span class="font-weight-bold">Keresés</span>
            </button>
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
        	<button class="btn btn-block btn-outline-success m-1" disabled>
              	<span class="font-weight-bold" v-show="list.length > 0">{{ list.length }} ügyfél</span>
              	<span class="font-weight-bold" v-show="list.length < 1">Sajnos nincs találat</span>
            </button>
        </div>
    </div>

    <hr>

    <div class="row d-flex justify-content-center align-items-center">
    	<div
    		class="col-12"
    		v-for="(item, index) in list"
    		:key="`g-${index}`"
    	>
    		<gorditem
    			:data="item"
    			:date="search.date"
	    	>
	    	</gorditem>
    	</div>
    </div>
</div>
</template>

<script>
import gorditem from './gordulo_item'
export default {
  	name: 'Gordulo',

  	components: {
  		gorditem
  	},

  	data () {
	    	return {
	      	list: [],
	      	search: {
	      		aktiv: 1,
	      		date: this.$moment(new Date()).subtract(4, 'years').format('YYYY'),
	      		regio_kezd: 0,
	      		regio_veg: 9999,
	      		telj_kezd: 0,
	      		telj_veg: 75,
	      		limit_kezd: 0,
	      		limit_veg: 100000,
	      		akt_kezd: 0,
	      		akt_veg: 999,
	      		automataa: true,
	      		automata_szerz: true
	      	}
	    }
  	},

  	methods: {
    
	    regio(kezd,veg){
	      	this.search.regio_kezd = kezd
	      	this.search.regio_veg = veg
	    },

    	load() {
			this.$Progress.start()
			this.isLoading = true
			this.req.post(`/stats/gordulo`,this.search)
				.then(res => {
					this.list = res.data.list
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
					this.isLoading = false
				})
    	}
  	}
}
</script>

<style scoped>
.divider {
  border: 1px solid black;
  margin-bottom: 15px;
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/stats/gordulo.vue